module.exports = __webpack_public_path__ + "static/media/portfolio_site_fruity_feels_1.68d5185f.png";